"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeachingBubbleContent = void 0;
var Utilities_1 = require("../../Utilities");
var TeachingBubbleContent_base_1 = require("./TeachingBubbleContent.base");
var TeachingBubble_styles_1 = require("./TeachingBubble.styles");
exports.TeachingBubbleContent = Utilities_1.styled(TeachingBubbleContent_base_1.TeachingBubbleContentBase, TeachingBubble_styles_1.getStyles, undefined, { scope: 'TeachingBubbleContent' });
//# sourceMappingURL=TeachingBubbleContent.js.map